import React, { Component } from 'react';
import { getNotificationsList,publishNotification, sendTestNotification } from '../../modules/Api';
import ReactTable from 'react-table'
import history from '../../modules/History';
import { END_POINT } from '../../constants/config';
import { Button, notification } from 'antd';
import ACL from '../../components/ACL';

class Notifications extends Component {
    constructor() {
        super();
        this.state = {
            items: [],
            pageSize: 15,
            count: 0,
            last_page: 1,
        }
    }

    componentDidMount() {
        // this.fetchData();
    }

    fetchData = (query = '') => {
        getNotificationsList(query, (data) => {this.setState({
            items: data.data,
            last_page: data.last_page,
            count: data.total,
            pageSize: data.per_page
        })});
        //getEventsCount(``, (count) => {this.setState({count})});
    }

    onChange(state) {
        this.setState({pageSize: state.pageSize});
        let sort = {
            order: 'desc',
            field: 'created_at',
        };
        if(state.sorted.length > 0) {
            sort = {
                order: state.sorted[0].desc ? 'desc': 'asc',
                field: state.sorted[0].id,
            }
        }

        let filterQuery = state.filtered.reduce((q, item) => {
            return item.value ? `${q}&${item.id}=${item.value}` : q;
        }, '');

        const query = `page=${state.page  + 1}&per_page=${state.pageSize}&${filterQuery}&sort=${JSON.stringify(sort)}`;

        this.fetchData(query);
    }

    publish(id) {
        const warningMessage = `آیا از منتشر کردن پوش اطمینان کامل دارید ؟ پوش ارسال خواهد شد. !`;
        if (window.confirm(warningMessage)) {
            let _this = this;
            publishNotification(id, (res) => {
                notification.open({
                    message: res.message,
                })
                _this.fetchData();
            });
        }
    }

    sendTest(id) {
        sendTestNotification(id, (res) => {
            notification.open({
                message: res.message,
            })
        });
    }

    render() {
        const columns = [
            {
                Header: 'آیدی',
                filterable: true,
                sortable: true,
                accessor: 'id',
            },
            {
                filterable: true,
                Header: 'عنوان',
                accessor: 'title',
            },
            {
                Header: 'پلت فرم',
                Cell: row => (row.original.platform == "1" ? "مرورگر" : (row.original.platform == "2" ? "موبایل" : "همه"))
            },
            {
                Header: 'آیکون',
                Cell: row => (row.original.icon && <img src={`${row.original.icon.includes('http') ? row.original.icon : END_POINT + row.original.icon}`} style={{width: '50px', height: '50px'}} alt={row.original.title}/>)
            },
            {
                Header: 'بنر',
                Cell: row => (row.original.banner && <img src={`${row.original.banner.includes('http') ? row.original.banner : END_POINT + row.original.banner}`} style={{width: '50px', height: '50px'}} alt={row.original.title}/>)
            },
            {
                Header: 'عملیات',
                accessor: 'delete',
                sortable: false,
                Cell: (row) => (
                    <React.Fragment>
                        {row.original.is_pre_publish == "1" ? <ACL component="span" has_permission="notification_management|notification_add"><Button type="warning" onClick={() => {this.publish(row.original.id)}} className="fa fa-trash" style={{color: 'tomato', cursor: 'pointer', marginTop: '20%'}} >انتشار </Button></ACL> : ""}
                        {row.original.sent_at ? "" : <ACL component="span" has_permission="notification_management|notification_add"><Button type="primary" onClick={() => {this.sendTest(row.original.id)}} className="fa fa-trash" style={{color: 'tomato', cursor: 'pointer', marginTop: '20%'}} >ارسال تست </Button></ACL>}
                    </React.Fragment>
                )
            },
        ]
        return(
            <div style={{textAlign: 'center'}}>
                <div class="btn-container">
                    <ACL component="span" has_permission="notification_add|notification_management"><Button type="primary" onClick={() => history.item.push(`/notifications/add`)}>افزودن اعلان جدید</Button></ACL>
                </div>
                <ReactTable
                    data={this.state.items}
                    columns={columns}
                    manual
                    onFetchData={(state) => {this.onChange(state)}}
                    defaultPageSize={parseInt(this.state.pageSize, 10)}
                    pages={this.state.last_page}

                />
            </div>
        );
    }
}

export default Notifications;


// WEBPACK FOOTER //
// ./src/containers/Notification/index.js